import "./Work.css";
import Fade from "react-reveal/Fade";

function Work({ id, name, description, url, github, image,builtWith,solutions }) {
  console.log(solutions.solution);
  return (
    <div className="work" id="work">
      <div className="work-detail">
        <Fade left>
          <div className="work-detail-details">
            <img src={image} alt="" />
            <div className="pad">
              <h3>{name}</h3>
              <div>
                <p className="work-detail-desc">{description}</p>
                <ul>{solutions.map((solution,index)=>(
                  <li  key={index}>{solution.solution}</li>
                ))}</ul>
                <p className="built-with">
                  <strong>Built with: </strong>&nbsp;
                  <span>{builtWith}</span>
                </p>
                <p className="work-detail-link">
                  <a href={url} target="_blank" rel="noreferrer">
                    Website Link
                  </a>
                  <a href={github} target="_blank" rel="noreferrer">
                    Github Link
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}

export default Work;
